var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 11,
    r: 2,
    fill: "#747475"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 2,
    fill: "#747475"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 23,
    r: 2,
    fill: "#747475"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMzQiIHZpZXdCb3g9IjAgMCAzNCAzNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSIxNyIgY3k9IjExIiByPSIyIiBmaWxsPSIjNzQ3NDc1IiAvPgogIDxjaXJjbGUgY3g9IjE3IiBjeT0iMTciIHI9IjIiIGZpbGw9IiM3NDc0NzUiIC8+CiAgPGNpcmNsZSBjeD0iMTciIGN5PSIyMyIgcj0iMiIgZmlsbD0iIzc0NzQ3NSIgLz4KPC9zdmc+Cg==";
export { SvgThreeDots as ReactComponent };